import { Component, inject } from '@angular/core';
import { DialogOrBottomSheetRef } from '@letly/ui-common';
import { ConsentPanelComponent } from './consent-panel.component';

@Component({
  selector: 'app-consent-dialog',
  imports: [ConsentPanelComponent],
  template: `
    <div role="dialog" aria-modal="true" aria-label="Your privacy choices" i18n-aria-label="@@core.consent.l1.title"
         class="tw-p-5 md:tw-p-6">
      <app-consent-panel mechanism="dialog" (decided)="close()"></app-consent-panel>
    </div>
  `,
  standalone: true
})
export class ConsentDialogComponent {
  private readonly ref = inject(DialogOrBottomSheetRef);

  close(): void {
    this.ref.close();
  }
}
